import { domain } from 'modules/data';

export const checkExpenseLinesRefLineNumbersUnique = (expenseLine: domain.NetSuiteExpenseLineExpenseReport[]) => {
    const refLineNumbers = expenseLine.map((expenseLine) => expenseLine.refLineNumber);

    const refLineNumbersUnique = [...new Set(refLineNumbers)];

    return refLineNumbers.length === refLineNumbersUnique.length;
};
